/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestLiquitySortedTroves extends Contract<ITestLiquitySortedTroves> {
  findInsertPosition: Call<(_NCIR: BigNumberish, _prevId: AddressLike, _nextId: AddressLike) => { upperHint_: string, lowerHint_: string }, ITestLiquitySortedTroves>
  'findInsertPosition(uint256,address,address)': Call<(_NCIR: BigNumberish, _prevId: AddressLike, _nextId: AddressLike) => { upperHint_: string, lowerHint_: string }, ITestLiquitySortedTroves>
}

let ITestLiquitySortedTrovesBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestLiquitySortedTrovesBytecode = '0x';
}

// prettier-ignore
export const ITestLiquitySortedTroves = contract<ITestLiquitySortedTroves>(ITestLiquitySortedTrovesBytecode)`
  function findInsertPosition(uint256 _NCIR, address _prevId, address _nextId) view returns (address upperHint_, address lowerHint_)
`;